import React from 'react';
import {Provider} from "react-redux";

import RewardIndexContainer from "./container/RewardIndexContainer";

import configure from '../../store/configure';
import {useParams} from "react-router-dom";

const RewardIndexPage = () => {
    const params = useParams();
    const data = params.data;

    return (
        <Provider store={configure}>
            <RewardIndexContainer
                data={data}
            />
        </Provider>
    );
};

export default RewardIndexPage;
